<template>
    <div class="form-row">
        <div class="col col-12 col-md-4">
            <az-input 
                :icon="sync ? '' : 'far fa-calendar-alt fa-fw'"
                type="select"
                placeholder="Livre"
                :optionsList="lista"
                optionsDisplay="search"
                optionsData="id"
                :shortkey="['ctrl', 'd']" 
                v-model="value.periodo">
                <template v-slot:button-pre>
                    <div class="input-group-prepend" v-if="sync">
                        <button type="button" class="btn btn-outline-primary" @click="$emit('sync')" :disabled="$store.state.loading" id="refresh-button">
                            <i class="fas fa-sync-alt fa-fw"></i>
                        </button>
                    </div>
                </template>
            </az-input>
        </div>
        <template v-if="value.periodo == 'ms'">
            <div class="col col-12 col-md-4">
                <az-input 
                    type="month"
                    v-model="value.mes_inicial" />
            </div>
            <div class="col col-12 col-md-4">
                <az-input 
                    type="month"
                    v-model="value.mes_final" />
            </div>
        </template>
        <template v-else-if="value.periodo == 'lm'">
            <div class="col col-12 col-md-8">
                <az-input
                    type="month"
                    icon="far fa-calendar-check fa-fw"
                    v-model="value.mes" />
            </div>
        </template>
        <template v-else-if="value.periodo && value.periodo == 's'">
            <div class="col col-12 col-md-8">
                <az-input 
                    icon="fas fa-equals fa-fw"
                    type="week"
                    :edicao="true"
                    v-model="value.semana" />
            </div>
        </template>
        <template v-else-if="value.periodo && value.periodo != 'ld'">
            <div class="col col-12 col-md-4">
                <az-input 
                    icon="fas fa-slash fa-fw"
                    :edicao="false" />
            </div>
            <div class="col col-12 col-md-4">
                <az-input 
                    icon="fas fa-slash fa-fw"
                    :edicao="false" />
            </div>
        </template>
        <template v-else>
            <div class="col col-12 col-md-4">
                <az-input 
                    :icon="value.periodo == 'ld' ? 'fas fa-equals fa-fw' : 'fas fa-greater-than-equal fa-fw'"
                    type="date"
                    :edicao="!value.periodo || value.periodo == 'ld'"
                    v-model="value.inicio" />
            </div>

            <template v-if="value.periodo == 'ld' && !!diahora">
                <div class="col col-12 col-md-2">
                    <az-input 
                        type="time"
                        v-model="value.hr_ini" />
                </div>

                <div class="col col-12 col-md-2">
                    <az-input 
                        type="time"
                        v-model="value.hr_fim" />
                </div>
            </template>

            <div class="col col-12 col-md-4" v-else-if="value.periodo == 'ld'">
                <az-input
                    type="text"
                    icon="fas fa-slash fa-fw"
                    :edicao="false" />
            </div>

            <div class="col col-12 col-md-4" v-else>
                <az-input 
                    icon="fas fa-less-than-equal fa-fw"
                    type="date"
                    :edicao="!value.periodo"
                    v-model="value.fim" />
            </div>
        </template>
    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from './AzInput.vue';

export default {
    props: ['value', 'sync', 'blockano', 'diahora'], 

    computed: { 
        lista: function () { 
            let items = [
                    { id: 'm', search: 'Mês Atual' },
                    { id: 'ma', search: 'Mês Anterior' },
                    { id: 'lm', search: 'Mês' },
                    { id: 'h', search: 'Hoje' },
                    { id: 'o', search: 'Ontem' },
                    { id: 'do', search: 'Desde Ontem' },
                    { id: 't', search: 'Amanhã' },
                    { id: 'ld', search: 'Dia' },
                    { id: 's', search: 'Semana' },
                    { id: 'u12', search: 'Últimas 12 horas' },
                    { id: 'u24', search: 'Últimas 24 horas' },
                    { id: 'u7', search: 'Últimos 07 dias' },
                    { id: 'u3', search: 'Últimos 30 dias' },
                    { id: 'u6', search: 'Últimos 60 dias' },
                    { id: 'u9', search: 'Últimos 90 dias' },
                 ];

            if ( !this.blockano ) { 
                items.push({ id: 'ms', search: 'Meses (Faixa)' });
                items.push({ id: 'a', search: 'Ano Atual' });
                items.push({ id: 'aa', search: 'Ano Anterior' });
            }

            return _.orderBy(items, 'search');
        }

    },

    components: { 
        AzInput,
    },

    watch: { 
        value: function(newValue) { 
            this.$emit('input', newValue);
            this.$emit('refresh');
        }
    }
}
</script>